'use client';

import classNames from 'classnames';
import React from 'react';
import Link from 'next/link';
import styles from './Breadcrumbs.module.scss';

type BreadcrumbLink = {
  title: string;
  url: string;
};

interface IBreadcrumbsProps { items: BreadcrumbLink[]; className?: string; }

const Breadcrumbs = ({ items, className }: IBreadcrumbsProps) => (
  <div className={classNames(styles.breadcrumbs, className)}>
    {items.map((item, index) => {
      const isCurrentItem = index === items.length - 1;

      return (
        <React.Fragment key={item.url}>
          <Link
            href={item.url}
            key={item.url}
            className={classNames(styles.breadcrumb, {
              [styles.active]: isCurrentItem,
            })}
            aria-disabled={isCurrentItem}
          >
            {item.title}
          </Link>
          <svg className={styles.arrowIcon}>
            <use
              href='/media/angle_down.svg#angleDown'
              xlinkHref='/media/angle_down.svg#angleDown'
            />
          </svg>
        </React.Fragment>
      );
    })}
  </div>
);

export default Breadcrumbs;
